<template>
    <tr
        v-for="month in row.data"
        class="row border-none group relative hover:bg-gray-tier-5"
    >
        <td
            v-for="(column, key) in columns"
            class="relative group first-of-type:!pl-6 !px-2.5 py-2 at1024:py-[14px]"
            :class="[
                {
                    'whitespace-nowrap':
                        !_.has(column, 'noWrap') && !column.noWrap === true,
                },
                { 'last-of-type:!pr-8': isSubTable },
                (typeof column.cellClass === 'function'
                    ? column.cellClass(month)
                    : column.cellClass) ?? '',
            ]"
        >
            <span
                v-if="
                    !(typeof column.component === 'function'
                        ? column.component(month)
                        : column.component)
                "
                v-html="
                    typeof column.path === 'function'
                        ? column.path(month)?.length
                            ? column.path(month)
                            : '—'
                        : String(
                              _.get(
                                  month,
                                  column.path,
                                  column.placeholder ?? '—'
                              )
                          ).length
                        ? _.get(month, column.path, column.placeholder ?? '—')
                        : column.placeholder ?? '—'
                "
            />
            <component
                :is="
                    typeof column.component === 'function'
                        ? column.component(month)
                        : column.component
                "
                v-else
                :placeholder="column.placeholder"
                v-bind="
                    typeof column.props === 'function'
                        ? column.props(month)
                        : column.props ?? {}
                "
            />
        </td>
    </tr>
    <tr class="text-gray-475 bg-gray-tier-5">
        <td
            :colspan="columns.length"
            class="relative group type-primary py-[14px]"
        >
            <div class="flex gap-4 justify-between pl-2">
                <span class="type-secondary">
<!--                    Total for <WarehouseCodeToStateFormat :code="_.toString(row.warehouse)" />:-->
                    Total for <strong>{{row.warehouse}}</strong>
                </span>
                <span class="pr-6">
                    <MoneyFormat :amount="row.total_sales" class="!font-bold" />
                </span>
            </div>
        </td>
    </tr>
</template>
<script setup>
import _ from "lodash";
import { ref } from "vue";

import { WarehouseCodeToStateFormat, MoneyFormat } from "@/Components";

const emit = defineEmits(["toggle-row"]);

const props = defineProps([
    "name",
    "columns",
    "row",
    "subTable",
    "isSubTable",
    "selectable",
    "selected",
]);

const showSubTable = ref(props.subTable?.show ?? false);
</script>
